import { Block } from 'baseui/block';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { EventCore } from '../../types/gptTypes';
import { GptEventDetailData } from './GptEventDetailData';

type Props = {
  event: EventCore;
};

function GptEventCardBody({ event }: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <Block
      className={css({
        padding: theme.sizing.scale400,
      })}
    >
      <GptEventDetailData event={event} />
    </Block>
  );
}

export default memo(GptEventCardBody);
